import { useEffect, useRef } from "react";

import { useLocation } from "react-router-dom";

/**
 * Used for situations where you need a reference to the apps current
 * location path with it's corresponding query parameters.
 * @returns a ref that wraps the current location path with any query params
 */
const useCurrentLocationRef = () => {
  const location = useLocation();
  const urlLocation = useRef(`${location.pathname}${location.search}`);
  useEffect(() => {
    urlLocation.current = `${location.pathname}${location.search}`;
  }, [location]);

  return urlLocation;
};

export default useCurrentLocationRef;
